import { EventEmitter, Injectable } from '@angular/core';
import { FormArray, FormGroup, NgForm } from '@angular/forms';
import { SafesimulationsClass } from '../models/safesimulations-class';
import { GlobalService } from './global.service';
import Swal from './swal-compat';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class ValidateService {
  public DadosInquerito: NgForm | null = null;
  public DadosFinalizarCompra: NgForm | null = null;

  constructor(public globalService: GlobalService) {}

  validateChildForm(parentForm: NgForm, formValidationResult: EventEmitter<boolean>) {
    if (parentForm && parentForm.valid) {
      console.log('Formulário pai é válido, você pode validar o formulário filho aqui.');

      // Execute a lógica de validação adicional para o formulário filho
      // Emita um evento para notificar o componente pai sobre a validação
      formValidationResult.emit(true);
    } else {
      console.log('Formulário pai não é válido.');
      formValidationResult.emit(false);
    }
  }

  ValidateFormBK(safesimulationsClass: any, DadosInquerito: NgForm) {
    if (safesimulationsClass as SafesimulationsClass) {
      safesimulationsClass.disabledNextButton = !DadosInquerito?.valid;
      safesimulationsClass.disabledNextButtonQuiz = !DadosInquerito?.valid;
    }

    this.DadosInquerito = DadosInquerito;
  }

  ValidateForm(safesimulationsClass: any, DadosInquerito: NgForm) {
    if (safesimulationsClass instanceof SafesimulationsClass && DadosInquerito) {
      safesimulationsClass.disabledNextButton = !DadosInquerito.valid;
      safesimulationsClass.disabledNextButtonQuiz = !DadosInquerito.valid;
    }

    this.DadosInquerito = DadosInquerito;
  }

  ValidateFormQuiz(safesimulationsClass: any, DadosInquerito: NgForm) {
    safesimulationsClass.disabledNextButtonQuiz = !DadosInquerito?.valid;
  }

  ValidateFormDadosFinalizarCompra(safesimulationsClass: SafesimulationsClass, DadosFinalizarCompra: NgForm) {
    console.log('ValidateFormDadosFinalizarCompra');
    safesimulationsClass.DadosFinalizarCompraValid = DadosFinalizarCompra.valid;
    this.DadosFinalizarCompra = DadosFinalizarCompra;

    // Na área do mediador, permite qualquer data de início de contrato,
    // EXCETO para pedidos de cotação de viagens Intermundial (a API da Intermundial exige datas futuras).
    const isMediador = this.globalService.selectedArea === 'Intermediaryarea';
    const isIntermundial = this.globalService.OpenComponent === 'ViagemquestionarioComponent';
    const skipDateValidation = isMediador && !isIntermundial;

    // Cria um objeto Date para a data atual.
    // Zera as horas, minutos, segundos e milissegundos para comparar apenas as datas, não o tempo exato.
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    // Compara as datas.
    if (
      !skipDateValidation &&
      (!safesimulationsClass.DataInicoContrato || safesimulationsClass.DataInicoContrato <= hoje)
    ) {
      safesimulationsClass.DadosFinalizarCompraValid = false;

      if (this.globalService.loggedUserClass?.Admin && this.globalService.EnableDevelopermode) {
        Swal.fire('Erro', 'Data Inicio de contrato inválido.', 'error');
      }
      // Aqui, você pode adicionar mais lógica, como mostrar uma mensagem de erro ao usuário.
    }

    if (!safesimulationsClass.NIF) {
      safesimulationsClass.DadosFinalizarCompraValid = false;
      if (this.globalService.loggedUserClass?.Admin && this.globalService.EnableDevelopermode) {
        Swal.fire('Erro', 'NIF inválido.', 'error');
      }
    }

    if (!safesimulationsClass.Name) {
      safesimulationsClass.DadosFinalizarCompraValid = false;

      if (this.globalService.loggedUserClass?.Admin && this.globalService.EnableDevelopermode) {
        Swal.fire('Erro', 'Nome inválido.', 'error');
      }
    }

    if (!safesimulationsClass.Email) {
      safesimulationsClass.DadosFinalizarCompraValid = false;

      if (this.globalService.loggedUserClass?.Admin && this.globalService.EnableDevelopermode) {
        Swal.fire('Erro', 'Email inválido.', 'error');
      }
    }

    if (!safesimulationsClass.Contact) {
      safesimulationsClass.DadosFinalizarCompraValid = false;

      if (!safesimulationsClass.Email) {
        safesimulationsClass.DadosFinalizarCompraValid = false;

        if (this.globalService.loggedUserClass?.Admin && this.globalService.EnableDevelopermode) {
          Swal.fire('Erro', 'Contacto inválido.', 'error');
        }
      }
    }
  }

  ValidateForm2(safesimulationsClass: any, form: FormGroup) {
    if (safesimulationsClass as SafesimulationsClass) {
      safesimulationsClass.disabledNextButton = !form.valid;
    }
  }

  inValidFieldsTextColor(value: boolean): string {
    return value ? 'black' : '#bbd6e2';
  }

  inValidFields(form: NgForm): string {
    let messages: string[] = [];

    if (!form.valid) {
      for (const field in form.controls) {
        const control = form.form.get(field);
        if (control.status === 'INVALID') {
          const fieldNameLowerCase = field.toLowerCase(); // Convertendo para minúsculas
          const message = this.globalService.validateFieldMessage.find(
            msg => msg.Field.toLowerCase() === fieldNameLowerCase,
          );
          if (message) {
            messages.push(message.Message);
          } else {
            messages.push(`${field} não encontrada.`);
          }
        }
      }
    }

    return messages.join('\r\n');
  }

  isBoolean(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    if (typeof value === 'string') {
      value = value.toLowerCase().trim();
      return value === 'true' || value === 'sim' || value === '1' || value === 'on' || value === 'yes';
    }

    return false;
  }

  getBooleanbk(value: any) {
    console.log(value);
    switch (value) {
      case true:
        return true;
      case 'true':
        return true;
      case 'Sim':
        return true;
      case 1:
        return true;
      case '1':
        return true;
      case 'on':
        return true;
      case 'yes':
        return true;
      default:
        return false;
    }
  }

  getBoolean(value: any) {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    if (typeof value === 'string') {
      value = value.toLowerCase().trim();
      return value === 'true' || value === 'sim' || value === '1' || value === 'on' || value === 'yes';
    }

    return false;
  }

  isValidIBANNumber(input) {
    if (!input) {
      return 0;
    }

    input = 'PT50' + input.replace('PT50', '').replace(/\s/g, '');
    const CODE_LENGTHS = {
      AD: 24,
      AE: 23,
      AT: 20,
      AZ: 28,
      BA: 20,
      BE: 16,
      BG: 22,
      BH: 22,
      BR: 29,
      CH: 21,
      CR: 21,
      CY: 28,
      CZ: 24,
      DE: 22,
      DK: 18,
      DO: 28,
      EE: 20,
      ES: 24,
      FI: 18,
      FO: 18,
      FR: 27,
      GB: 22,
      GI: 23,
      GL: 18,
      GR: 27,
      GT: 28,
      HR: 21,
      HU: 28,
      IE: 22,
      IL: 23,
      IS: 26,
      IT: 27,
      JO: 30,
      KW: 30,
      KZ: 20,
      LB: 28,
      LI: 21,
      LT: 20,
      LU: 20,
      LV: 21,
      MC: 27,
      MD: 24,
      ME: 22,
      MK: 19,
      MR: 27,
      MT: 31,
      MU: 30,
      NL: 18,
      NO: 15,
      PK: 24,
      PL: 28,
      PS: 29,
      PT: 25,
      QA: 29,
      RO: 24,
      RS: 22,
      SA: 24,
      SE: 24,
      SI: 19,
      SK: 24,
      SM: 27,
      TN: 24,
      TR: 26,
    };

    // tslint:disable-next-line: one-variable-per-declaration
    let iban = input.toUpperCase().replace(/[^A-Z0-9]/g, ''),
      code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),
      digits;

    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return 0;
    }

    // tslint:disable-next-line: only-arrow-functions
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
    });

    return this.mod97(digits);
  }

  // tslint:disable-next-line: variable-name
  mod97(string) {
    // tslint:disable-next-line: one-variable-per-declaration
    let checksum = string.slice(0, 2),
      fragment;

    for (let offset = 2; offset < string.length; offset += 7) {
      fragment = checksum + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }

    return checksum;
  }

  isNumber(value: string | number): boolean {
    return value != null && value !== '' && !isNaN(Number(value.toString()));
  }

  isEmail(search: string): boolean {
    var serchfind: boolean;

    let regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

    serchfind = regexp.test(search);

    return serchfind;
  }

  ReturnNumber(val) {
    if (isNaN(val)) {
      return null;
    } else {
      // tslint:disable-next-line: radix
      return parseInt(val);
    }
  }

  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  // ValidateFormDadosClaims(insuranceclaimsClass: any, dados: NgForm) {
  //   // console.log(DadosFinalizarCompra.valid);
  //   insuranceclaimsClass.DadosValid = dados.valid;

  // }

  keyPressWeight(event: KeyboardEvent) {
    const charCode = event.key;
    const currentValue = (event.target as HTMLInputElement).value;

    // Teclas permitidas: números (0-9), ponto (.), Backspace, Tab, Delete, setas
    const allowedKeys = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '.',
      'Backspace',
      'Tab',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];

    // Verifica se a tecla é permitida
    if (!allowedKeys.includes(charCode)) {
      event.preventDefault();
      return false;
    }

    // Validação específica para o ponto decimal
    if (charCode === '.') {
      // Permite apenas um ponto decimal
      if (currentValue.includes('.')) {
        event.preventDefault();
        return false;
      }
      // Não permite ponto como primeiro caractere
      if (currentValue === '') {
        event.preventDefault();
        return false;
      }
    }

    return true;
  }

  keyPressOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.key;

    // Permitir apenas números inteiros (0 a 9) e teclas permitidas
    if (charCode < '0' || charCode > '9') {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  markAllControlsAsTouched(formGroup: FormGroup | NgForm): void {
    if (!formGroup) {
      return;
    }

    if (formGroup instanceof NgForm) {
      if (formGroup.form) {
        this.markAllControlsAsTouched(formGroup.form);
      }
      return;
    }

    if (formGroup instanceof FormGroup) {
      Object.keys(formGroup.controls).forEach((controlName: string) => {
        const control = formGroup.get(controlName);
        if (control) {
          control.markAsTouched({ onlySelf: true });
          control.markAsDirty({ onlySelf: true });
          control.updateValueAndValidity({ onlySelf: true });
          if (control instanceof FormGroup || control instanceof FormArray) {
            this.markAllControlsAsTouched(control as any);
          }
        }
      });
      if (typeof (formGroup as any).markAllAsTouched === 'function') {
        (formGroup as any).markAllAsTouched();
      }
    }
  }

  // Função para lidar com estruturas circulares ao fazer stringify
  safeStringify(obj: any) {
    const seen = new Set();
    return JSON.stringify(obj, (_key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return; // Ignorar referências circulares
        }
        seen.add(value);
      }
      return value;
    });
  }

  isValidDate(date: any): boolean {
    // Verifica se a data é uma instância válida de Date
    if (date instanceof Date && !isNaN(date.getTime())) {
      return true;
    }

    // Verifica se a data é uma instância válida de Dayjs
    if (dayjs.isDayjs(date) && date.isValid()) {
      return true;
    }

    // Verifica se a data é uma string válida
    if (typeof date === 'string') {
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    }

    return false;
  }
}
